import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/dist/client/image-component.js");
